import {
    Flex,
    Box,
    FormLabel,
    Input,
    Button,
    useToast,
    Radio,
    RadioGroup,
    Stack,
    Text
} from '@chakra-ui/react'
import { addDoc, collection } from 'firebase/firestore'
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage'
import React, { useEffect, useState } from 'react'
import db, {storage} from '../firebase'

function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}
  

function AddPlayer() {

    const toast = useToast()
    const [data, setData] = useState({})
    const [image, setImage] = useState(null)

    const [playerAtts, setPlayerAtts] = useState({
        'Batsman': false,
        'Bowler': false,
        'Wicket Keeper': false,
        'All Rounder': false    
    })

    const handleChange = (e) => {
        setData(s => ({
            ...s, 
            [e.target.name]: e.target.value
        }))
    }

    const uploadImage = async () => {

        if(!image || 
            !data.name || 
            !data.type || 
            !data.phone || 
            !data.mid ||
            !data.category
            )
        {
            toast({
                position: 'bottom-right',
                title: `Fill All The Detials`,
                status: 'warning',
                duration: 1000,
                isClosable: true,
            })
            return
        }

        toast({
            position: 'bottom-right',
            title: `Adding Player`,
            // status: `Selling Player`,
            duration: 1000,
            isClosable: true,
        })

        const storageRef = ref(storage, `${uuidv4()}`)
        const uplaodTask = await uploadBytesResumable(storageRef, image)
        
        const url = await getDownloadURL(uplaodTask.ref)
        
        const wholeData = {
            ...data,
            atts: {...playerAtts},
            image: url
        }

        await addDoc(collection(db, 'players'),  {...wholeData});

        toast({
            position: 'bottom-right',
            title: `Player Added`,
            status: `success`,
            duration: 1000,
            isClosable: true,
        })

        setData({})
        setImage(null)
        Object.keys(playerAtts).map(key => playerAtts[key] = false)
        setPlayerAtts({...playerAtts})
    }

    const postData = async () => {        
        await uploadImage();
    }

    

    return (
        <Flex
            direction={'column'}
            pb={5}
            gap={5}
            justifyContent={'center'}
            alignItems={'center'}
        >

        <Flex
            justifyContent={'center'}
            direction={'row'}
            wrap={'wrap'}
            mx={'auto'}
            p={10}
            gap={10}
        >
            <Box w={'30%'}>
                <FormLabel htmlFor='name'>Full Name</FormLabel>
                <Input  
                    id='name' 
                    type='text' 
                    name="name" 
                    onChange={(e) =>handleChange(e)}
                    value={data?.name || ""}
                />
            </Box>

            <Box w={'30%'}>
                <FormLabel htmlFor='phone'>Photo</FormLabel>
                <Input 
                    id='photo' 
                    type='file' 
                    name="photo"
                    border={'none'}
                    accept="image/png, image/jpeg"
                    onChange={(e) => setImage(e.target.files[0])}
                    />
            </Box>
            
            <Box w={'30%'}>
                <FormLabel htmlFor='phone'>Phone</FormLabel>
                <Input 
                    id='phone' 
                    type='phone' 
                    name="phone"
                    onChange={(e) =>handleChange(e)}
                    value={data?.phone || ""}
                />
            </Box>
            <Box w={'30%'}>
                <FormLabel htmlFor='category'>Category</FormLabel>
                <Input 
                    id='category' 
                    type='text' 
                    name="category"
                    onChange={(e) =>handleChange(e)}
                    value={data?.category || ""}
                />
            </Box>
            <Box w={'30%'}>
                <FormLabel htmlFor='mid'>Membership No.</FormLabel>
                <Input 
                    id='mid' 
                    type='text' 
                    name="mid"
                    onChange={(e) =>handleChange(e)}
                    value={data?.mid || ""}
                />
            </Box>
            <Box w={'30%'}>
                <FormLabel htmlFor='type'>Lefty/Righty</FormLabel>
                <RadioGroup name="type" id="type" onChange={(e) => setData(d => ({...d, type:e}))} value={data?.type}>
                <Stack direction='row'>
                    <Radio value='lefty'>Lefty</Radio>
                    <Radio value='righty'>Righty</Radio>
                </Stack>


                </RadioGroup>
            </Box>
            
        </Flex>

        <Flex
                alignItems={'center'}
                gap={5}
            >
                <Text>Last Year Stats</Text>
                <Box w={'30%'}>
                    <FormLabel htmlFor='score'></FormLabel>
                    <Input 
                        id='score' 
                        type='text' 
                        name="score"
                        placeholder={'Score'}
                        onChange={(e) =>handleChange(e)}
                        value={data?.score || ""}
                    />
                </Box>
                <Box w={'30%'}>
                    <FormLabel htmlFor='wickets'></FormLabel>
                    <Input 
                        id='wickets' 
                        type='text' 
                        name="wickets"
                        placeholder={'Wickets'}
                        onChange={(e) =>handleChange(e)}
                        value={data?.wickets || ""}
                    />
                </Box>
            </Flex>

            
            <Flex
                gap={5}
                wrap={'wrap'}
            >
                {Object.keys(playerAtts).map(key => {

                    return (
                        <Text
                            px={4}
                            py={2}
                            border={'1px'}
                            borderColor={'gray.700'}
                            borderRadius={20}
                            key={key}
                            cursor={'pointer'}
                            transition="all 0.25s"
                            _hover={{
                                borderColor:'gray.500'
                            }}

                            bg={playerAtts[key]?'cyan.600':""}

                            onClick={() => setPlayerAtts({...playerAtts, [key]: !playerAtts[key]})}
                        
                        >{key}</Text>
                    )

                })}
            </Flex>



            <Button mx={"auto"} w={'90%'} onClick={()=>postData()}>Submit</Button>

        </Flex>
    )
}

export default AddPlayer